import StyledAccordion from './StyledAccordion';

export default StyledAccordion;
